// extracted by mini-css-extract-plugin
export var cardIcon = "_4c-4";
export var checkboxCard = "_4c-0";
export var checkboxCardSelected = "_4c-1";
export var disabled = "_4c-2";
export var outerBorder = "_4c-3";
export var spacerMedium = "_4c-7";
export var spacerSmall = "_4c-6";
export var spacerXsmall = "_4c-5";